import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import LikeButton from "components/LikeButton";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/solid";
import BagIcon from "components/BagIcon";
import NcInputNumber from "components/NcInputNumber";
import { PRODUCTS, Product } from "data/data";
import {
  NoSymbolIcon,
  ClockIcon,
  SparklesIcon,
} from "@heroicons/react/24/outline";
import IconDiscount from "components/IconDiscount";
import Prices from "components/Prices";
import toast from "react-hot-toast";
import detail1JPG from "images/products/detail3-1.webp";
import detail2JPG from "images/products/detail3-2.webp";
import detail3JPG from "images/products/detail3-3.webp";
import NotifyAddTocart from "./NotifyAddTocart";
import { Link } from "react-router-dom";
import { apiGetItemData } from "services/MenuService";
import { Disclosure } from "@headlessui/react";
import Checkbox from "shared/Checkbox/Checkbox";
import NcImage from "shared/NcImage/NcImage";

export interface ProductQuickViewProps {
  className?: string;
  productId?: number
}

const ProductQuickView: FC<ProductQuickViewProps> = ({ className = "", productId }) => {
  const { sizes, variants, status, allOfSizes } = PRODUCTS[0];
  const LIST_IMAGES_DEMO = [detail1JPG, detail2JPG, detail3JPG];
  const [variantActive, setVariantActive] = React.useState(0);
  const [sizeSelected, setSizeSelected] = React.useState(sizes ? sizes[0] : "");
  const [qualitySelected, setQualitySelected] = React.useState(1);
  const [itemData, setItemData] = useState<Product[]>([])
  const [checkedItem, setCheckedItem] = useState<Record<number, boolean>>({});

  //OK
  const handleCheckboxChange = (checked: boolean, name: number) => {
    setCheckedItem((prevCheckedItem) => {
      return ({
        ...prevCheckedItem,
        [name]: checked
      })
    }
    );
  }

  //OK
  const getItemData = async () => {
    try {
      const response = await apiGetItemData()
      const responseData = response.data as Product[];
      const filteredData = responseData.filter((item: Product) => item.id === productId);
      setItemData(filteredData)
    }
    catch (error) {
      console.log('Error', error)
    }
  }
  useEffect(() => {
    getItemData()
  }, [])

  //OK
  const notifyAddTocart = () => {
    toast.custom(
      (t) => (
        <NotifyAddTocart
          productImage={LIST_IMAGES_DEMO[0]}
          qualitySelected={qualitySelected}
          show={t.visible}
          sizeSelected={sizeSelected}
          variantActive={variantActive}
        />
      ),
      { position: "top-right", id: "nc-product-notify", duration: 3000 }
    );
  };

  const renderStatus = () => {
    if (!status) {
      return null;
    }
    const CLASSES =
      "absolute top-3 left-3 px-2.5 py-1.5 text-xs bg-white dark:bg-slate-900 nc-shadow-lg rounded-full flex items-center justify-center text-slate-700 text-slate-900 dark:text-slate-300";
    if (status === "New in") {
      return (
        <div className={CLASSES}>
          <SparklesIcon className="w-3.5 h-3.5" />
          <span className="ml-1 leading-none">{status}</span>
        </div>
      );
    }
    if (status === "50% Discount") {
      return (
        <div className={CLASSES}>
          <IconDiscount className="w-3.5 h-3.5" />
          <span className="ml-1 leading-none">{status}</span>
        </div>
      );
    }
    if (status === "Sold Out") {
      return (
        <div className={CLASSES}>
          <NoSymbolIcon className="w-3.5 h-3.5" />
          <span className="ml-1 leading-none">{status}</span>
        </div>
      );
    }
    if (status === "limited edition") {
      return (
        <div className={CLASSES}>
          <ClockIcon className="w-3.5 h-3.5" />
          <span className="ml-1 leading-none">{status}</span>
        </div>
      );
    }
    return null;
  };

  const descriptionContent = () => {
    return (
      <>
        {itemData.map((item) => (
          <div key={item.id} className="w-full rounded-2xl space-y-2.5">
            <h3 className="flex items-center justify-between w-full px-4 py-2 font-medium text-left bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
              Description
            </h3>
            <p>
              {item.description}
            </p>
          </div>
        ))
        }
      </>
    )
  }

  const modifierSetsContent = () => {
    return (
      <>
        {itemData.map((item, index) => (
          <div key={index} className="w-full rounded-2xl space-y-2.5">
            {item?.modifierSets?.map((modifier, index) => (
              <Disclosure key={index}>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="flex items-center justify-between w-full px-4 py-2 font-medium text-left bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
                      <span>{modifier.name}</span>
                      {!open ? (
                        <PlusIcon className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                      ) : (
                        <MinusIcon className="w-4 h-4 text-slate-600 dark:text-slate-400" />
                      )}
                    </Disclosure.Button>
                    {modifier?.modifierSetModifierItems
                      ?.map((modifierCheck, index) => (
                        <Disclosure.Panel
                          key={index}
                          className='p-4 pt-3 last:pb-0 text-slate-600 text-sm dark:text-slate-300 leading-6'
                          as="div"
                        >
                          <Checkbox
                            key={modifierCheck.modifierItem?.id}
                            sizeClassName="w-5 h-5"
                            labelClassName="text-sm font-normal"
                            label={modifierCheck.modifierItem?.name}
                            name={modifierCheck.modifierItem?.name}
                            onChange={(e) => handleCheckboxChange(e, modifierCheck.modifierItem?.id as number)}
                            defaultChecked={checkedItem[modifierCheck.modifierItem?.id as number] ? true : false}
                          />

                        </Disclosure.Panel>
                      ))}
                  </>
                )}
              </Disclosure>
            ))}
          </div>
        ))}
      </>
    );
  }

  const renderSectionContent = () => {
    return (
      <div className="space-y-8">
        {itemData.map((item) => (
          <div>
            <h2 key={item.id} className="text-2xl font-semibold hover:text-primary-6000 transition-colors">
              <Link to={`/product-detail/${item.id}`}>{item.name}</Link>
            </h2>
            <div className="flex items-center mt-5 space-x-4 sm:space-x-5">
              <Prices
                contentClass="py-1 px-2 md:py-1.5 md:px-3 text-lg font-semibold"
                price={item.price}
              />
              <div className="h-6 border-l border-slate-300 dark:border-slate-700"></div>
              <div className="flex items-center">
                <Link
                  to={`/product-detail/${item.id}`}
                  className="flex items-center text-sm font-medium"
                >
                  {
                    item.isAvailable ? <span>Available</span> : <span>Out of stock</span>
                  }
                </Link>
                <span className="hidden sm:block mx-2.5">·</span>
                <div className="hidden sm:flex items-center text-sm">
                  <SparklesIcon className="w-3.5 h-3.5" />
                  <span className="ml-1 leading-none">{status}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
        {/* ---------- Description ----------  */}
        {descriptionContent()}
        <div className="flex space-x-3.5">
          <div className="flex items-center justify-center bg-slate-100/70 dark:bg-slate-800/70 px-2 py-3 sm:p-3.5 rounded-full">
            <NcInputNumber
              defaultValue={qualitySelected}
              onChange={setQualitySelected}
            />
          </div>
          <ButtonPrimary
            className="flex-1 flex-shrink-0"
            onClick={notifyAddTocart}
          >
            <BagIcon className="hidden sm:inline-block w-5 h-5 mb-0.5" />
            <span className="ml-3">Add to cart</span>
          </ButtonPrimary>
        </div>
        <hr className=" border-slate-200 dark:border-slate-700"></hr>
        {/* ---------- ModifierContent ----------  */}
        {modifierSetsContent()}
      </div>
    );
  };

  return (
    <div className={`nc-ProductQuickView ${className}`}>
      <div className="lg:flex">
        {itemData.map((item, index) => (
          <div key={index} className="w-full lg:w-[50%] ">
            <div className="relative">
              <div className="aspect-w-16 aspect-h-16">
                <NcImage
                  src={item.imageUrl}
                  containerClassName="flex aspect-w-11 aspect-h-11 w-full h-0"
                  className="w-full rounded-xl object-cover"
                  alt="product detail 1"
                />
              </div>
              {renderStatus()}
              <LikeButton className="absolute right-3 top-3 " />
            </div>
            <div className="hidden lg:grid grid-cols-2 gap-3 mt-3 sm:gap-6 sm:mt-6 xl:gap-5 xl:mt-5">
              <NcImage
                src={item.imageUrl}
                containerClassName="flex aspect-w-11 aspect-h-11 w-full h-0"
                className="w-full rounded-xl object-cover"
                alt="product detail 1"
              />
              <NcImage
                src={item.imageUrl}
                containerClassName="flex aspect-w-11 aspect-h-11 w-full h-0"
                className="w-full rounded-xl object-cover"
                alt="product detail 1"
              />
            </div>
          </div>
        ))}
        {/* SIDEBAR */}
        <div className="w-full lg:w-[50%] pt-6 lg:pt-0 lg:pl-7 xl:pl-8">
          {renderSectionContent()}
        </div>
      </div>
    </div>
  );
};

export default ProductQuickView;
